module.exports = __webpack_public_path__ + "img/Hints_1.b58a9c50.gif";